@if (viewUser() && !editingShare()) {
	<lvr-heading [showEditButton]="canOpenUserSettings()" (editClicked)="openEdit()">
		{{ 'user.specialist_details.title' | transloco }}
	</lvr-heading>

	@if (showTransferButton()) {
		<lvr-button
			variant="primary"
			[label]="'base.button.move' | transloco"
			[type]="'button'"
			(clicked)="openMove()"
			icon="arrow_forward"
		></lvr-button>
	}

	@if (user(); as selectedUser) {
		<lvr-admin-user-view
			[user]="selectedUser"
			[userGender]="userGender()"
			[canReadPositionShareDetails]="canReadPositionShareDetails()"
		></lvr-admin-user-view>

		@if (canReadPositionShares()) {
			<lvr-position-share-list
				[userId]="+selectedUser.id"
				[canEditPositionShares]="canEditPositionShares()"
				(editShare)="onEditShare($event)"
			>
			</lvr-position-share-list>
		}
	}
}

<!-- Edit Position Share -->
@if (editingShare() && canEditPositionShares()) {
	<lvr-position-share-edit
		class="mt-4"
		[positionShare]="editingShare()"
		(shareSaved)="onShareSaved($event)"
		(shareCancel)="onShareCancel()"
	>
	</lvr-position-share-edit>
}

@if (!viewUser()) {
	<div class="no-user">
		<p>{{ 'user.table.no_entries' | transloco }}</p>
	</div>
}
